var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrectTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4691 0.253795C18.0437 0.678668 18.1723 1.49573 17.7544 2.07993L7.4684 16.4602C7.24741 16.7707 6.90589 16.9627 6.5282 16.9954C6.15051 17.0281 5.78487 16.8851 5.51969 16.6155L0.376685 11.3863C-0.125562 10.8756 -0.125562 10.0463 0.376685 9.53562C0.878931 9.02496 1.69458 9.02496 2.19683 9.53562L6.27506 13.6822L15.6771 0.539767C16.095 -0.0444325 16.8986 -0.175163 17.4732 0.24971L17.4691 0.253795Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectTick);
export default __webpack_public_path__ + "static/media/correct-tick.048ff97b0105b9731dcdd7a05cb9d421.svg";
export { ForwardRef as ReactComponent };